<ui-form-field-layout
	[isRequired]="isRequired()"
	[title]="title()"
	[subtitle]="subtitle()"
	[isValid]="isValid()"
	[hint]="hint()"
	[suffix]="suffix()"
>
	<div class="ui-input" slot="input">
		<div>
			<input
				#input
				[ariaLabel]="title()"
				[ngClass]="inputDesignClass()"
				[attr.maxLength]="passwordMaxLength"
				[type]="showPassword() ? 'text' : 'password'"
				[placeholder]="'Password'"
				[autocomplete]="autocompleteValue()"
				[ngModel]="lastValidValue()"
				(ngModelChange)="handleModelChange($event)"
			/>
		</div>
		@if (enablePasswordPreview()) {
		<div class="push-top" libFlexRow [libFlexRowGap]="'8px'">
			<div libFlexColumn>
				<lib-checkbox-form-input
					[label]="'Show password'"
					[checked]="showPassword()"
					(valueChange)="handleShowPasswordChange($event)"
				></lib-checkbox-form-input>
			</div>
		</div>
		}
	</div>
</ui-form-field-layout>
